import { useMemo, useState } from "react";
import { Animated, Platform } from "react-native";
import variables from "../../styles/variables";
import AdBanner from "./AdBanners/AdBanner";
import { useAtom } from "jotai";
import {
  appHeightAndWidthAtom,
  advertisingAtom,
  advertOverlayModalAtom,
  tabAdLayoutAtom,
} from "../../atoms";
import { useShowTabAd } from "../../hooks/useShowTabAd";
import { logEvent } from "../../client/analytics/trackPageView";
import { advertClick } from "../../client/adverts";

const TabAdvert = ({ tabBarAdBottomAmount }) => {
  const [appHeightAndWidth] = useAtom(appHeightAndWidthAtom);
  const [adverts] = useAtom(advertisingAtom);
  const [advertOverlayModal] = useAtom(advertOverlayModalAtom);
  const [, setTabAdLayout] = useAtom(tabAdLayoutAtom);
  const [tabAdvert, setTabAdvert] = useState<JSX.Element | null>(null);

  const { shouldShowTabAd } = useShowTabAd();

  useMemo(() => {
    if (!!adverts && !adverts?.tab) {
      setTabAdvert(null);
      return;
    }

    if (!adverts?.tab) return;

    const tabAd = (
      <AdBanner
        accessibilityLabel="Banner Advert"
        onPress={() => {
          logEvent({ key: "sticky-clicked", data: {} });
          advertClick(adverts.tab.link_url);
        }}
        style={[
          {
            aspectRatio: 8.14 / 1,
            backgroundColor: variables.colors.palette.rtv.primary,
            minHeight: appHeightAndWidth.appWidth / 8.14,
          },
          Platform.OS == "web" ? { justifyContent: "flex-end" } : {},
        ]}
        ad={adverts.tab}
      />
    );

    setTabAdvert(tabAd);
  }, [adverts?.tab?.campaign_id]);

  if (!shouldShowTabAd) return null;

  return (
    <Animated.View
      style={{
        marginBottom:
          Platform.OS === "ios"
            ? tabBarAdBottomAmount?._value + 10
            : tabBarAdBottomAmount,
      }}
      onLayout={(event) => {
        if (tabAdvert) setTabAdLayout(event.nativeEvent.layout);
      }}
    >
      {tabAdvert}
    </Animated.View>
  );
};

export default TabAdvert;
